
import { srpTemplate } from "../models/SRPSchema";
import { schemaValidation } from "./schemaValidation";

export function navigateJson(path, jsonContent){
    const pathArray = path.split('/');

    // First element will always be empty due to the path starting with '/' in AJV
    let updatedObj = jsonContent;
    for(let i = 1; i < pathArray.length; i++){
        updatedObj = updatedObj[pathArray[i]];
    }
    return updatedObj;
}

function findDefaultLocation(path){
    const pathArray = path.split('/');

    // First element will always be empty due to the path starting with '/' in AJV
    let updatedObj = srpTemplate;
    for(let i = 1; i < pathArray.length; i++){

        console.log(Array.isArray(updatedObj))
        if(Array.isArray(updatedObj)){
            updatedObj = updatedObj[0];
            continue;
        }
    
        updatedObj = updatedObj[pathArray[i]];
    }
    return updatedObj;
}

function deleteField(path, field, jsonContent){
    let location = navigateJson(path, jsonContent);
    delete location[field];
}

// Used for both creating fields and blanking fields that don't match the schema
function setFieldToDefault(path, field, jsonContent){
    let location = navigateJson(path, jsonContent);
    let locationDefault = findDefaultLocation(path)
    location[field] = locationDefault[field];
}

function handleRequired(path, params, jsonContent){
    // Need special case for "index" if schema is not changed

    // Only if the 'required' error is 'missingProperty', create the field.
    if(params.hasOwnProperty("missingProperty")){
        const field = params.missingProperty;
        setFieldToDefault(path, field, jsonContent);
    }

}


function fixValidationErrors(jsonOut, errors){

    //Blank out field errors
        // if flashableClusters-artifactURL needs blanking, also blank name/version?
    //ADD missing fields

    // Fields error only needs to be blanked it would cause a form error, need to expirement to find what that might be

    errors.forEach(error => {
        switch(error.keyword){
            case "additionalProperties":
                deleteField(error.instancePath, error.params.additionalProperty, jsonOut);
                break;
            case "required":
                handleRequired(error.instancePath, error.params, jsonOut);
                break;
            default:
                break;
        }
    });

    return jsonOut;
}

    function universalFixes(jsonContent: any){
        // Patch any common issues that might cause schema validation errors
        return jsonContent;
    }


    export function schemaUpgrade(jsonContent: any, schema: any){
        let jsonOut = jsonContent
    
        switch(jsonContent.srpSchemaVersion){
            case "0.0.7":
            case "0.0.8":
            case "0.0.9":
                return {
                    jsonOut,
                    errorMessage: "Invalid SRP Schema Version. Upgrading from version prior to 0.1.0 is not supported.",
                }
             
            case "0.1.0":
                break;

            default:
                return {
                    jsonOut,
                    errorMessage: "Invalid SRP Schema Version.",
                }
        }

        console.log(`Upgraded JSON Content:\n${JSON.stringify(jsonOut, null, '   ')}`);

        
        // Patch any problems from a hand-made SRP that might cause issues in the form
        jsonOut = universalFixes(jsonOut);

        // prevent schema validation is loading from localstorage to avoid delay in page loading
        // (temporary fix while better solution is found)

        if(!schema.hasOwnProperty("noSchema") && jsonContent.srpSchemaVersion !== "0.1.0"){    
            const validation = schemaValidation(schema, jsonContent);

            if(!validation.isValid){
                console.log(validation.errors);

                //handle errors by setting fields to default/deleting extra fields.
                jsonOut = fixValidationErrors(jsonOut, validation.errors);
            }
        }

        console.log(`Upgraded JSON Content:\n${JSON.stringify(jsonOut, null, '   ')}`);

        return {
            jsonOut,
            errorMessage: "",
        }
    }